const candidates = [
  {
    id: 'trump',
    name: 'Donald J. Trump',
    short: 'DT',
    description: '47th President of the United States · Real estate developer, television personality, convicted felon. Born 14 June 1946, Queens, New York.',
    status: 'Active · rising',
    statusType: 'danger',
    tier: 1,
    score: 71,
    peakScore: 74,
    peakDate: '22 Mar 2026',
    daysTracked: 117,
    scoredEvents: 43,
    weeklyDelta: 3.2,
    color: '#E24B4A',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37 · 2 Thess 2:3–4', score: 17.6, max: 20, pct: 88 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7 · Dan 7:23', score: 16.0, max: 20, pct: 80 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 10.9, max: 15, pct: 73 },
      { name: 'Persecution of dissent', ref: 'Rev 13:7 · Dan 7:21', score: 11.7, max: 15, pct: 78 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25 · 1 Thess 5:3', score: 6.0, max: 10, pct: 60 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14 · 2 Thess 2:9', score: 6.5, max: 10, pct: 65 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3 · Rev 17:8', score: 9.5, max: 10, pct: 95 },
    ],
    recentEvents: [
      { date: '14 Apr 2026', text: '"I was sent by God to save this country" — rally statement, third occurrence in 30 days', category: 'Cat. I', delta: '+0.8', type: 'danger' },
      { date: '11 Apr 2026', text: 'Tariff executive order: market access conditioned on bilateral loyalty pledges', category: 'Cat. III', delta: '+0.5', type: 'warning' },
      { date: '03 Apr 2026', text: 'DOJ moves against three prosecutors involved in 2023–24 indictments', category: 'Cat. IV', delta: '+0.6', type: 'danger' },
      { date: '28 Mar 2026', text: 'Greenland annexation remarks renewed at NATO summit — "it will happen"', category: 'Cat. II', delta: '+0.4', type: 'warning' },
      { date: '22 Mar 2026', text: 'Peak score 74% recorded following "God\'s chosen leader" statements at National Prayer Breakfast', category: 'Peak score', delta: '', type: 'danger' },
    ],
    criteria: [
      {
        category: 'I',
        title: 'Claims of supreme authority & self-deification',
        ref: 'Dan 11:36–37 · 2 Thess 2:3–4 · Rev 13:5–6',
        score: 17.6,
        max: 20,
        pct: 88,
        color: '#E24B4A',
        pillBg: '#FCEBEB',
        pillColor: '#A32D2D',
        items: [
          {
            text: 'Publicly positions self as uniquely chosen, messianic, or above all other leaders',
            score: '1.0 / 1.0',
            evidence: 'At a July 2024 rally Trump stated "I am your warrior, I am your justice… I am your retribution." In Apr 2026 declared "God chose me to lead this nation" — third such statement in 30 days. Palm Beach supporters have circulated merchandise depicting Trump with a halo.',
            verse: '"He shall exalt himself and magnify himself above every god, and shall speak astonishing things against the God of gods."',
            verseRef: 'Daniel 11:36 · full score awarded',
          },
          {
            text: 'Speaks with contempt toward traditional religious authority or reframes faith around personal loyalty',
            score: '0.9 / 1.0',
            evidence: 'Has repeatedly instrumentalised evangelical clergy as validators while dismissing theological critique as "radical left religion." Sold a branded Bible ("God Bless the USA Bible") for $59.99 — the Word of God, conveniently co-branded.',
            verse: '"He shall pay no attention to the gods of his fathers… He shall magnify himself above all."',
            verseRef: 'Daniel 11:37 · 0.9 awarded — contempt present, full apostasy pending',
          },
          {
            text: 'Claims or implies divine endorsement exclusively and directly, bypassing institutional religion',
            score: '0.8 / 1.0',
            evidence: 'Survived assassination attempt in Butler, PA (Jul 2024) and immediately framed survival as divine intervention. "God kept me here for a reason." Fist-pump photo became a global icon of apparent providential favour.',
            verse: '"It opened its mouth to utter blasphemies against God, blaspheming his name and his dwelling."',
            verseRef: 'Revelation 13:6 · 0.8 awarded — direct claim, institutional bypass confirmed',
          },
        ],
      },
      {
        category: 'VII',
        title: 'Miraculous survival & cult of death-defiance',
        ref: 'Rev 13:3 · Rev 13:12 · Rev 17:8',
        score: 9.5,
        max: 10,
        pct: 95,
        color: '#E24B4A',
        pillBg: '#FCEBEB',
        pillColor: '#A32D2D',
        items: [
          {
            text: 'Survives or escapes what appears to be a fatal or career-ending blow — to widespread astonishment',
            score: '1.0 / 1.0',
            evidence: 'Butler, Pennsylvania, 13 July 2024. Bullet grazes ear by millimetres. Rises, fist raised, blood on face. Photographs distributed globally within minutes. The prophetic optics committee could not have designed this better.',
            verse: '"One of its heads seemed to have a mortal wound, but its mortal wound was healed, and the whole earth marveled as they followed the beast."',
            verseRef: 'Revelation 13:3 · full score · the wound, the healing, the marveling — all present',
          },
          {
            text: 'Returns from apparent political, legal, or reputational death to renewed power',
            score: '1.0 / 1.0',
            evidence: 'Two impeachments. 91 criminal indictments across four jurisdictions. Multiple bankruptcies. Banned from social media. Lost the 2020 election. Returned as 47th President with popular vote majority. The scorecard practically fills itself.',
            verse: '"The beast that you saw was, and is not, and is about to rise from the bottomless pit… and the dwellers on earth will marvel."',
            verseRef: 'Revelation 17:8 · full score · "was, and is not, and is" describes 2016–2024 arc with eerie precision',
          },
          {
            text: 'Cultivates personal mythology of indestructibility; followers treat survival as miraculous vindication',
            score: '0.95 / 1.0',
            evidence: '"They\'re not coming after me, they\'re coming after you — I\'m just standing in the way." MAGA movement explicitly frames every failed prosecution as divine protection. Mainstream evangelical leaders declared Butler a miracle from the pulpit.',
            verse: '"Who is like the beast, and who can fight against it?"',
            verseRef: 'Revelation 13:4 · 0.95 — deducting 0.05 for not yet achieving full global consensus on invincibility',
          },
        ],
      },
    ],
  },
  {
    id: 'musk',
    name: 'Elon Musk',
    short: 'EM',
    description: 'Tech oligarch, CEO of Tesla & SpaceX, owner of X, head of DOGE. Born 28 June 1971, Pretoria, South Africa.',
    status: 'Active · volatile',
    statusType: 'warning',
    tier: 2,
    score: 54,
    peakScore: 61,
    peakDate: '15 Feb 2026',
    daysTracked: 117,
    scoredEvents: 31,
    weeklyDelta: 1.4,
    color: '#BA7517',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 8.0, max: 20, pct: 40 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 12.0, max: 20, pct: 60 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 12.0, max: 15, pct: 80 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 8.0, max: 15, pct: 53 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 4.0, max: 10, pct: 40 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 8.0, max: 10, pct: 80 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 2.0, max: 10, pct: 20 },
    ],
    recentEvents: [
      { date: '09 Apr 2026', text: 'X platform deploys AI content moderation suppressing anti-DOGE commentary globally', category: 'Cat. VI', delta: '+0.4', type: 'warning' },
      { date: '01 Apr 2026', text: 'Starlink used as geopolitical leverage in three separate international negotiations', category: 'Cat. II', delta: '+0.5', type: 'warning' },
    ],
    criteria: [],
  },
  {
    id: 'obama',
    name: 'Barack Obama',
    short: 'BO',
    description: '44th President of the United States. Born 4 August 1961, Honolulu, Hawaii. Currently retired from office.',
    status: 'Retired · stable',
    statusType: 'neutral',
    tier: 1,
    score: 34,
    peakScore: 36,
    peakDate: '10 Jan 2026',
    daysTracked: 117,
    scoredEvents: 8,
    weeklyDelta: 0,
    color: '#5DCAA5',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 4.0, max: 20, pct: 20 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 6.0, max: 20, pct: 30 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 5.0, max: 15, pct: 33 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 6.0, max: 15, pct: 40 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 4.0, max: 10, pct: 40 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 6.0, max: 10, pct: 60 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 3.0, max: 10, pct: 30 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'biden',
    name: 'Joe Biden',
    short: 'JB',
    description: '46th President of the United States. Born 20 November 1942, Scranton, Pennsylvania. Retired from office Jan 2025.',
    status: 'Retired · stable',
    statusType: 'neutral',
    tier: 1,
    score: 29,
    peakScore: 31,
    peakDate: '05 Feb 2026',
    daysTracked: 117,
    scoredEvents: 6,
    weeklyDelta: 0,
    color: '#B4B2A9',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 2.0, max: 20, pct: 10 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 5.0, max: 20, pct: 25 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 5.0, max: 15, pct: 33 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 5.0, max: 15, pct: 33 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 5.0, max: 10, pct: 50 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 4.0, max: 10, pct: 40 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 3.0, max: 10, pct: 30 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'hitler',
    name: 'Adolf Hitler',
    short: 'AH',
    description: 'Dictator of the Third Reich. Born 20 April 1889, Braunau am Inn, Austria. Deceased 30 April 1945. Historical benchmark.',
    status: 'Deceased · fixed score',
    statusType: 'neutral',
    tier: 3,
    score: 83,
    peakScore: 83,
    peakDate: 'Historical',
    daysTracked: null,
    scoredEvents: null,
    weeklyDelta: 0,
    color: '#888780',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 18.0, max: 20, pct: 90 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 18.0, max: 20, pct: 90 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 11.0, max: 15, pct: 73 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 14.0, max: 15, pct: 93 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 8.0, max: 10, pct: 80 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 9.0, max: 10, pct: 90 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 5.0, max: 10, pct: 50 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'nero',
    name: 'Nero',
    short: 'NE',
    description: 'Emperor of Rome 54–68 AD. Born 15 December 37 AD. The original benchmark — many early Christians identified him directly with the Beast of Revelation.',
    status: 'Deceased · fixed score',
    statusType: 'neutral',
    tier: 3,
    score: 61,
    peakScore: 61,
    peakDate: 'Historical',
    daysTracked: null,
    scoredEvents: null,
    weeklyDelta: 0,
    color: '#AFA9EC',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 14.0, max: 20, pct: 70 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 12.0, max: 20, pct: 60 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 8.0, max: 15, pct: 53 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 13.0, max: 15, pct: 87 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 5.0, max: 10, pct: 50 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 7.0, max: 10, pct: 70 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 2.0, max: 10, pct: 20 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'xi',
    name: 'Xi Jinping',
    short: 'XJ',
    description: 'President of the People\'s Republic of China since 2013. Born 15 June 1953, Beijing. Architect of the social credit system.',
    status: 'Active · rising',
    statusType: 'warning',
    tier: 1,
    score: 69,
    peakScore: 71,
    peakDate: '01 Mar 2026',
    daysTracked: 117,
    scoredEvents: 22,
    weeklyDelta: 0.8,
    color: '#7F77DD',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 15.0, max: 20, pct: 75 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 16.0, max: 20, pct: 80 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 13.0, max: 15, pct: 87 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 13.0, max: 15, pct: 87 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 5.0, max: 10, pct: 50 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 5.0, max: 10, pct: 50 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 2.0, max: 10, pct: 20 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'putin',
    name: 'Vladimir Putin',
    short: 'VP',
    description: 'President of the Russian Federation. Born 7 October 1952, Leningrad. Has held power continuously since 1999 in various capacities.',
    status: 'Active · watching',
    statusType: 'warning',
    tier: 1,
    score: 67,
    peakScore: 70,
    peakDate: '14 Mar 2026',
    daysTracked: 117,
    scoredEvents: 19,
    weeklyDelta: 0.5,
    color: '#D85A30',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 13.0, max: 20, pct: 65 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 17.0, max: 20, pct: 85 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 9.0, max: 15, pct: 60 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 13.0, max: 15, pct: 87 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 8.0, max: 10, pct: 80 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 6.0, max: 10, pct: 60 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 1.0, max: 10, pct: 10 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'thiel',
    name: 'Peter Thiel',
    short: 'PT',
    description: 'Co-founder of Palantir and PayPal. Born 11 October 1967, Frankfurt, Germany. Ideological architect of Silicon Valley authoritarianism.',
    status: 'Active · watching',
    statusType: 'warning',
    tier: 2,
    score: 47,
    peakScore: 49,
    peakDate: '20 Feb 2026',
    daysTracked: 117,
    scoredEvents: 12,
    weeklyDelta: 0.3,
    color: '#EF9F27',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 7.0, max: 20, pct: 35 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 10.0, max: 20, pct: 50 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 9.0, max: 15, pct: 60 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 7.0, max: 15, pct: 47 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 4.0, max: 10, pct: 40 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 7.0, max: 10, pct: 70 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 3.0, max: 10, pct: 30 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'altman',
    name: 'Sam Altman',
    short: 'SA',
    description: 'CEO of OpenAI. Born 22 April 1985, Chicago. Oversees the development of artificial general intelligence with notable eschatological enthusiasm.',
    status: 'Active · rising',
    statusType: 'warning',
    tier: 2,
    score: 41,
    peakScore: 43,
    peakDate: '01 Apr 2026',
    daysTracked: 117,
    scoredEvents: 14,
    weeklyDelta: 0.6,
    color: '#1D9E75',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 6.0, max: 20, pct: 30 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 9.0, max: 20, pct: 45 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 8.0, max: 15, pct: 53 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 4.0, max: 15, pct: 27 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 5.0, max: 10, pct: 50 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 8.0, max: 10, pct: 80 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 1.0, max: 10, pct: 10 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'karp',
    name: 'Alex Karp',
    short: 'AK',
    description: 'CEO of Palantir Technologies. Born 2 October 1967, New York. Builds the surveillance infrastructure that makes the others possible.',
    status: 'Active · watching',
    statusType: 'neutral',
    tier: 2,
    score: 45,
    peakScore: 47,
    peakDate: '10 Mar 2026',
    daysTracked: 117,
    scoredEvents: 10,
    weeklyDelta: 0.2,
    color: '#F0997B',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 4.0, max: 20, pct: 20 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 9.0, max: 20, pct: 45 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 10.0, max: 15, pct: 67 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 9.0, max: 15, pct: 60 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 4.0, max: 10, pct: 40 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 7.0, max: 10, pct: 70 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 2.0, max: 10, pct: 20 },
    ],
    recentEvents: [],
    criteria: [],
  },
  {
    id: 'zuckerberg',
    name: 'Mark Zuckerberg',
    short: 'MZ',
    description: 'CEO of Meta (Facebook, Instagram, WhatsApp). Born 14 May 1984, White Plains, New York. Controls the social graph of 3 billion humans.',
    status: 'Active · flat',
    statusType: 'neutral',
    tier: 2,
    score: 44,
    peakScore: 46,
    peakDate: '05 Jan 2026',
    daysTracked: 117,
    scoredEvents: 11,
    weeklyDelta: 0,
    color: '#85B7EB',
    categories: [
      { name: 'Self-deification & supreme authority', ref: 'Dan 11:36–37', score: 5.0, max: 20, pct: 25 },
      { name: 'Global dominion ambitions', ref: 'Rev 13:7', score: 10.0, max: 20, pct: 50 },
      { name: 'Economic control & the Mark', ref: 'Rev 13:16–17', score: 10.0, max: 15, pct: 67 },
      { name: 'Persecution of dissent', ref: 'Dan 7:21', score: 7.0, max: 15, pct: 47 },
      { name: 'False peace & deceptive covenants', ref: 'Dan 8:25', score: 4.0, max: 10, pct: 40 },
      { name: 'Signs, wonders & propaganda', ref: 'Rev 13:13–14', score: 7.0, max: 10, pct: 70 },
      { name: 'Miraculous survival cult', ref: 'Rev 13:3', score: 1.0, max: 10, pct: 10 },
    ],
    recentEvents: [],
    criteria: [],
  },
];

export const getCandidate = (id) => candidates.find(c => c.id === id);
export const getAllCandidates = () => candidates;
export const getTopCandidate = () => [...candidates].sort((a, b) => b.score - a.score)[0];
export default candidates;
